module.exports = __webpack_public_path__ + "img/Egood45.7233f7f8.png";